import axios from 'axios'
import { BehaviorSubject } from 'rxjs'
import config from './config'

const isExpired = (dt) => {
    return new Date(dt).getTime() < new Date().getTime()
}

class RequestQueue {
    authResult$ = new BehaviorSubject(
        localStorage.getItem('authResult')
            ? JSON.parse(localStorage.getItem('authResult'))
            : {}
    )

    constructor() {
        this.queue = []
        this.isProcessing = false
    }

    // authResult$ = new BehaviorSubject(localStorage.getItem("authResult") ? JSON.parse(localStorage.getItem("authResult")) : {});
    setAuthResult(token) {
        this.authResult$.next(token)
        localStorage.setItem('authResult', JSON.stringify(token))
    }

    getAuthResult() {
        return this.authResult$.value
    }

    async refreshAccessToken() {
        const url = '/api/Auth/Token/Refresh'
        try {
            const response = await axios.post(
                `${config.getApiBaseUrl() + url}`,
                {
                    userId: this.authResult$.value.userId,
                    sessionId: this.authResult$.value.sessionId,
                    refreshToken: this.authResult$.value.refreshToken,
                }
            )
            this.authResult$.next(response.data)
            localStorage.setItem('authResult', JSON.stringify(response.data))
        } catch (error) {
            console.error('Error refreshing access token:', error)
            if (isExpired(this.authResult$.value.refreshTokenExpirationDate)) {
                window.location.href = '/#/login'
            }
        }
    }

    addRequest(request) {
        this.queue.push(request)
        if (!this.isProcessing) {
            this.processQueue()
        }
    }

    async processQueue() {
        this.isProcessing = true
        while (this.queue.length > 0) {
            const request = this.queue.shift()
            await this.sendRequest(request)
        }
        this.isProcessing = false
    }

    async sendRequest(request) {
        try {
            // if (validateObjectIsNotEmpty(this.authResult$.value)) {
            //     request.config.headers.Authorization = `Bearer ${this.authResult$.value.token}`;
            // }
            console.log(
                this.authResult$.value.accessToken,
                'this.authResult$.value.accessToken'
            )
            const response = await axios({
                method: request.config.method,
                url: `${config.getApiBaseUrl() + request.config.url}`,
                data: request.config.data,
                headers: {
                    ...request.config.headers,
                    Authorization: `Bearer ${this.authResult$.value.accessToken}`,
                },
            })
            return request.resolve(response)
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    await this.refreshAccessToken()
                    if (this.authResult$.value) {
                        const response = await axios({
                            method: request.config.method,
                            url: `${config.getApiBaseUrl() + request.config.url}`,
                            data: request.config.data,
                            headers: {
                                ...request.config.headers,
                                Authorization: `Bearer ${this.authResult$.value.accessToken}`,
                            },
                        })
                        return request.resolve(response)
                    } else {
                        return request.reject(error)
                    }
                } else {
                    return request.reject(error)
                }
            } else {
                return request.reject(error)
            }
        }
    }
}

export default new RequestQueue()
